const es = require("./language_json/es.json");

export default es;
